
export const MAX_PAGE = 5;
